import "./IssuanceStatusFilter.css";

import { ProjectIssuanceConstants } from "../../../constants";
import { MultiSelect } from "../MultiSelect";

export interface IssuanceStatusFilterProps {
  // Currently selected issuance statuses.
  values?: string[] | null;
  onChange: (statuses: string[]) => void;
  placeholder?: string;
  label?: string;
  className?: string;
  disabled?: boolean;
  corners?: "rounded" | "default";
}

/*
  Reusable issuance-status multi-select filter (a thin, status-specific wrapper around MultiSelect)
  intended to sit inline in a page/toolbar or card header. It owns the status options so every
  surface that filters inventory by status offers the same three, in the same order, under the same
  label. Presentational — the caller owns the selection, so it can be driven from any state and
  mocked directly in Storybook.
*/
export const IssuanceStatusFilter = ({
  values,
  onChange,
  placeholder = "Issuance status",
  label = " ",
  className,
  disabled = false,
  corners = "default",
}: IssuanceStatusFilterProps): JSX.Element => (
  <MultiSelect
    label={label}
    className={`IssuanceStatusFilter ${className ?? ""}`}
    placeholder={placeholder}
    data={ProjectIssuanceConstants.ISSUANCE_STATUS_SELECT_DATA}
    values={values}
    onChange={onChange}
    corners={corners}
    disabled={disabled}
  />
);
